import { useEffect } from 'react';

export const useConversionReportListRefresh = (enabled, refresh) => {
  useEffect(() => {
    if (!enabled) return undefined;
    let refreshing = false;
    const timer = setInterval(async () => {
      if (refreshing) return;
      refreshing = true;
      try {
        await refresh();
      } finally {
        refreshing = false;
      }
    }, 60000);
    return () => clearInterval(timer);
  }, [enabled, refresh]);
};
